import axios from "axios";
// const apiKey = process.env.REACT_APP_APIKEY
// const baseUrl = process.env.REACT_APP_BASEURL

export const getNewsList = async () => {
  const news = axios.get(
    // `${baseUrl}`
    // `${baseUrl}/top-headlines?country=id&apiKey=${apiKey}`
    "https://api-berita-indonesia.vercel.app/cnn/terbaru/"
    // "https://berita-indo-api.vercel.app/v1/cnbc-news/"
    // "https://newsapi.org/v2/top-headlines?country=id&apiKey=07c0199b0fe743e5a87aef73822b88df"
    )
    
    // return ((await news).data.articles)
    return ((await news).data.data.posts)
    // console.log({TestBE: (await news).data})
}

export const category = async (c) => {
  const category = await axios.get(`https://api-berita-indonesia.vercel.app/cnn/${c}/`);
  return category.data;
  // console.log(c);
};